// extracted by mini-css-extract-plugin
export default {"counter":"QuantityCounter_counter__AKiYN"};